<template>
  <div>
    <div>
        <a-input class="a_select_self margin_self" v-model="searchData.factorName" allowClear placeholder="检测物质" />
        <a-select class="a_select_self margin_self" allowClear placeholder="类别" v-model="searchData.subcategoryId"  style="width: 160px;" 
                           show-search :filter-option="filterOption">
                    <a-select-option :value="item.categoryId" v-for="(item, index) in list" :key="index">
                                 {{ item.categoryName }}
                    </a-select-option>
            </a-select>
            <a-button type="primary" @click="search" style="margin-right: 5px">查询</a-button>
    </div>
    <div>
        <div class="title">
                <span>请选择属于该分类下需要检测的物质（多选）：</span>
        </div>
        <div class="body" id="content_main_center_scroll">

        <a-table :data-source="examineList" bordered :loading="loading" :pagination="false" ref="examineListRef"
                :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"  :row-selection="{ selectedRowKeys: selectedRowKeys[pagination.current], onChange: onSelectChange }">
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="factorName" title="检测物质名称" ellipsis="true" data-index="factorName" />
                <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
        </a-table>
        </div>
        <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange"
          />
            
    </div>
  


  </div>
</template>

<script>
import {getChargeList} from '@/api/surrounding'
export default {
     props:[
        'examineList',
        'pagination',
        'selectedRowKeys',
        'selecteVal'
    ],
    data() {
        return {
            searchData: {
                subcategoryId: undefined,
                factorName: '',
            },
            // examineList: [],
            // selectedRowKeys: '',
            scroll_y: 150,
            list: []
            // 	pagination:{ //分页数据
			//      pageSizeOptions: ['10', '20', '30', '40', '50'],
            //      current : 1,
            //      pageSize: 10,
            //      totalCount: 0
            // },

        }
    },
    created() {
        //获取类别
        getChargeList({
            parentId: 1000
        }).then(res => {
            if(res.code == 200) {
                this.list = res.data

            } else {
                this.$message.error(res.msg)
            }
        })
        	var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() + 400
				}, 1000)
			

    },
    methods: {
         //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        //查询
        search() {
            console.log(this.searchData, 'searchData============')
            console.log('111111111111111111111111111')
            this.$emit('changeList', this.searchData)

        },
        onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
        this.$emit('changeData', this.pagination)

        },
    //多选事件
    onSelectChange(selectedRowKeys, val) {
        console.log(selectedRowKeys, val,'selectedRowKeys, val')
       this.selectedRowKeys[this.pagination.current] = selectedRowKeys
        this.$emit('changeData')
       this.selecteVal[this.pagination.current] = val
       console.log( this.selecteVal,'selectedRowKeys, val')
       this.$emit('getVal', this.selecteVal)
    },
    }

}
</script>

<style>
.body {
    margin: 10px;
}

</style>